import React, {Component} from 'react';
import {connect} from 'react-redux';
import GuestLayout from "../Layout/GuestLayout";
import Button from '../../components/common/Buttons/Button';

class PaymentResult extends Component {
    state = {
        isSuccess: null,
    };

    componentDidMount() {
        const params = new URLSearchParams(this.props.location.search);
        const success = params.get('success');
        this.setState({
            isSuccess: success === 'true'
        });
    }

    handleGoHome = () => {
        this.props.history.push('/home');
    }

    render() {
        const {isSuccess} = this.state;

        if (isSuccess === null) {
            return (
                <GuestLayout>
                    <div className="cp-page cp-page-login justify-content-start">
                        <div className="card-guest card-full-height">
                            <div className="message">
                                <div className="message-left text-muted">
                                    <i className="fas fa-spinner fa-spin"></i>
                                </div>
                                <div className="message-right">
                                    <h4 className="text-muted">Loading...</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </GuestLayout>
            );
        }

        return (
            <GuestLayout>
                <div className="cp-page cp-page-login justify-content-start">
                    <div className="card-guest card-full-height">

                        <div className="message">

                            <div className={"message-left" + (isSuccess ? ' text-success' : ' text-danger')}>
                                <i className={"fas fa-" + (isSuccess ? 'check-circle' : 'times-circle')} style={{fontSize: '3rem'}}></i>
                            </div>

                            <div className="message-right">
                                <h4 className={isSuccess ? 'text-success' : 'text-danger'}>
                                    {isSuccess ? 'Payment Successful!' : 'Payment Failed'}
                                </h4>
                                <p>
                                    {isSuccess
                                        ? 'Your payment has been processed successfully. Thank you! You can safety close this tab!'
                                        : 'We were unable to process your payment. Please try again or contact support.'}
                                </p>

                                {/*<div className="mt-4">*/}
                                {/*    <Button*/}
                                {/*        type="button"*/}
                                {/*        className="btn btn-primary"*/}
                                {/*        onClick={this.handleGoHome}*/}
                                {/*    >*/}
                                {/*        Go Home*/}
                                {/*    </Button>*/}
                                {/*</div>*/}
                            </div>

                        </div>

                    </div>
                </div>
            </GuestLayout>
        );
    }
}

PaymentResult.propTypes = {};

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentResult);
